// import { APPROVE_STATUS_LIST, MY_APPROVE_STATUS_LIST } from './const'

export const SEARCH_SCHEMA = [
  {
    itemName: 'companyName',
    label: '企业名称',
    type: 'input',
  },
  {
    itemName: 'companyCode',
    label: '企业ID',
    type: 'input',
  },
  {
    itemName: 'applyRangeDate',
    label: '申请日期',
    type: 'rangePicker',
    format: 'YYYY-MM-DD',
    allowClear: true,
  },
  {
    itemName: 'id',
    label: '申请流水号',
    type: 'input',
  },
  {
    itemName: 'creditManager',
    label: '信用主管',
    type: 'select',
    selectList: [],
  },
]

export const BATCH_SCHEMA = [
  {
    itemName: 'id',
    label: '申请流水号',
    type: 'input',
  },
  {
    itemName: 'applyRangeDate',
    label: '申请日期',
    type: 'rangePicker',
    allowClear: true,
  },
]

// ------------------账期调整审批历史记录------------------
// export const TERM_SEARCH_SCHEMA = [
//   {
//     itemName: 'name',
//     label: '企业名称',
//     type: 'input',
//   },
//   {
//     itemName: 'code',
//     label: '企业ID',
//     type: 'input',
//   },
//   {
//     itemName: 'applyRangeDate',
//     label: '申请日期',
//     type: 'rangePicker',
//     format: 'YYYY-MM-DD',
//     allowClear: true,
//   },
// ]
